import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/anybill-partner-portal-v3/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/app/anybill-partner-portal-v3/layouts/empty.vue").then(m => m.default || m)),
  "svg-sprite": defineAsyncComponent(() => import("#build/svg-sprite.vue").then(m => m.default || m))
}